import dynamic from "next/dynamic";
import { useRouter } from "next/router";

import { useSiteDisabledStore } from "@/store/zustand/siteDisabledStore";

const SiteDisabled403Client = dynamic(
  () => import("./SiteDisabled403").then((m) => m.SiteDisabled403),
  { ssr: false }
);

/**
 * Full-screen 403 when tryActivateSiteDisabled403 runs off /home routes.
 * SiteDisabled403 is client-only so antd/lucide do not run during SSR.
 */
export function SiteDisabledOverlay() {
  const router = useRouter();
  const active = useSiteDisabledStore((s) => s.active);

  if (!active) return null;

  const path = String(router.asPath ?? "").split("?")[0] ?? "";
  if (path === "/home" || path.startsWith("/home/")) return null;

  return <SiteDisabled403Client className="z-[100]" />;
}
